<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";

/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader },
    props:['pastoral','bloquear_encuesta'],
    data() {
        return {
            title: "Evaluación Pastoral",
            items: [
                {
                text: "Utility",
                href: "/"
                },
                {
                text: "Starter Page",
                active: true
                }
            ],
            
        };
    },
    created() {
    },
    methods: {
    }
};
</script>
<template>
    <div class="mt-3">
        <h5>Evaluación Pastoral</h5>
        <div class="card bg-soft-primary p-3">
            <h5>Escala</h5>
            <div class="table-responsive">
                <table class="table table-bordered mb-0">
                    <thead>
                        <tr>
                            <th colspan="2">Puntaje</th>
                            <th>Tipo conducta</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="text-center"><b>D</b></td>
                            <td>Débil</td>
                            <td>Lo realizo raras veces. Necesito ayuda.</td>
                        </tr>
                        <tr>
                            <td class="text-center"><b>I</b></td>
                            <td>Incipiente</td>
                            <td>Lo realizo solo algunas veces. Debo mejorar.</td>
                        </tr>
                        <tr>
                            <td class="text-center"><b>S</b></td>
                            <td>Satisfactorio</td>
                            <td>Lo realizo a menudo. Puedo mejorar.</td>
                        </tr>
                        <tr>
                            <td class="text-center"><b>A</b></td>
                            <td>Avanzado</td>
                            <td>Lo realizo con frecuencia.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="mt-3">
            <h5>Dimensión Pastoral</h5>
            <p class="font-size-14">Los indicadores de pastoral, debido a su relevancia pero también a la dificultad para
            obtener evidencias, no forman parte del instrumento de evaluación y no se incorporan en
            los resultados cuantitativos. Tienen su propia escala de apreciación y solo son
            autoevaluados, a fin de tener una referencia de crecimiento para el/la evaluado/a. No
            obstante, se espera que sus resultados cualitativos sean motivo de diálogo y análisis en la
            entrevista de retroalimentación, buscando también la mejora. Los indicadores fueron
            redactados a partir de cada uno de los núcleos del Marco Formativo Pastoral.
            </p>
        </div>
        <div class="mt-3">
            <h4>AUTOEVALUACIÓN</h4>
            <div class="table-responsive">
                <table class="table table-bordered table-hover mb-0">
                    <thead>
                        <tr>
                            <th>Indicador</th>
                            <th>Puntaje</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <p><em>“Es una gracia muy grande el que Dios se digne llamarnos a trabajar en la extensión de su Reino”.
                                (Carta a Hna. Regina, 1877) BMP</em></p>
                                <p>1. Desarrollo mi compromiso de Fe participando en instancias
                                formativas a fin de colaborar en el anuncio del Evangelio.</p>
                            </td>
                            <td>
                                <select class="custom-select" :disabled="bloquear_encuesta" v-model="pastoral.p1">
                                    <option value="" disabled>Seleccione un Puntaje</option>
                                    <option value="1">D Débil</option>
                                    <option value="2">I Incipiente</option>
                                    <option value="3">S Satisfactorio</option>
                                    <option value="4">A Avanzado</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p><em>“Aspiren a la santidad, profunda humildad, gran amor a Dios y al prójimo, mucha paciencia y
                                amabilidad con todos, principalmente con quienes conviven” (Carta a Berta, 1849) BMP</em></p>
                                <p>2. Promuevo con mi estilo de vida a hacer de mi institución una
                                comunidad de hermanos unidos, siendo corresponsable de la
                                comunión y el encuentro.</p>
                            </td>
                            <td>
                                <select class="custom-select" :disabled="bloquear_encuesta" v-model="pastoral.p2">
                                    <option value="" disabled>Seleccione un Puntaje</option>
                                    <option value="1">D Débil</option>
                                    <option value="2">I Incipiente</option>
                                    <option value="3">S Satisfactorio</option>
                                    <option value="4">A Avanzado</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p><em>“Dios hace todo bien. A Él debemos alabar y bendecir en todo tiempo andando con alegría nuestro
                                camino. ¡Aleluya! (Carta a Hna. Walburga, 1872) BMP</em></p>
                                <p>3. Colaboro y participo en las celebraciones comunitarias de la fe,
                                uniéndome y formando parte de la comunidad creyente.</p>
                            </td>
                            <td>
                                <select class="custom-select" :disabled="bloquear_encuesta" v-model="pastoral.p3">
                                    <option value="" disabled>Seleccione un Puntaje</option>
                                    <option value="1">D Débil</option>
                                    <option value="2">I Incipiente</option>
                                    <option value="3">S Satisfactorio</option>
                                    <option value="4">A Avanzado</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p><em>“Ningún esfuerzo me parezca demasiado grande en bien de los que sufren”
                                (Retiro 23/6/1843) BMP</em></p>
                                <p>4. Me integro a las iniciativas solidarias y fraternas de la institución
                                promoviendo la caridad cristiana como expresión del Carisma que
                                nos identifica.</p>
                            </td>
                            <td>
                                <select class="custom-select" :disabled="bloquear_encuesta" v-model="pastoral.p4">
                                    <option value="" disabled>Seleccione un Puntaje</option>
                                    <option value="1">D Débil</option>
                                    <option value="2">I Incipiente</option>
                                    <option value="3">S Satisfactorio</option>
                                    <option value="4">A Avanzado</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p><em>“¡Oh Dios mío! Te agradezco las innumerables gracias y los numerosos beneficios que me has
                                concedido, especialmente por la gracia de mi vocación”
                                (Retiro, 10/10/1854) BMP</em></p>
                                <p>5. Promuevo con mi palabra y mi testimonio una cultura vocacional
                                que permita a todos/as descubrir y construir su propio proyecto de
                                vida y su lugar en la Iglesia y el mundo para construir la civilización
                                del amor desde mi bautismo.</p>
                            </td>
                            <td>
                                <select class="custom-select" :disabled="bloquear_encuesta" v-model="pastoral.p5">
                                    <option value="" disabled>Seleccione un Puntaje</option>
                                    <option value="1">D Débil</option>
                                    <option value="2">I Incipiente</option>
                                    <option value="3">S Satisfactorio</option>
                                    <option value="4">A Avanzado</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p><em>“Oh tómame tú mismo en tu escuela, mi amado maestro. Con todo gusto quiero aprender de ti,
                                Señor. Te pido una inefable amabilidad y afabilidad en el trato con los demás con el fin de conducirlos
                                hacia ti. (Retiro, 10/2/1853) BMP</em></p>
                                <p>6. Canalizo a través de mi tarea cotidiana, mi rol como agente pastoral
                                y mi tarea misionera de acrecentar el sentido pastoral en todo lo
                                que hago en la institución.</p>
                            </td>
                            <td>
                                <select class="custom-select" :disabled="bloquear_encuesta" v-model="pastoral.p6">
                                    <option value="" disabled>Seleccione un Puntaje</option>
                                    <option value="1">D Débil</option>
                                    <option value="2">I Incipiente</option>
                                    <option value="3">S Satisfactorio</option>
                                    <option value="4">A Avanzado</option>
                                </select>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="mt-3">
            <h5>ESCRITURA EN LA AUTOEVALUACIÓN</h5>
            <p>(completar donde pueda expresar mejor los desafíos que surgen de la autoevaluación)</p>
            <b-form-group id="example text" label="Mis propuestas para la mejora son:" label-for="text">
                <b-form-textarea id="textarea" :disabled="bloquear_encuesta" v-model="pastoral.t1" placeholder="Ingresar mejoras" rows="3" max-rows="6"></b-form-textarea>
            </b-form-group>
            <b-form-group id="example text" label="Los aspectos donde necesito ayuda son:" label-for="text">
                <b-form-textarea id="textarea" :disabled="bloquear_encuesta" v-model="pastoral.t2" placeholder="Ingresar mejoras" rows="3" max-rows="6"></b-form-textarea>
            </b-form-group>
        </div>
    </div>
</template>